module.exports = __webpack_public_path__ + "static/media/chat-ok.ad8a3e66.svg";